import { useTranslation } from 'react-i18next'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import { useIsSA } from './useIsSA'

/**
 * Label for the patient's primary identifier field.
 *
 * SEHA (en-SA / ar-SA) captures a National ID / Iqama ID / Border Number instead
 * of a social security number, so every surface that shows the identifier — the
 * patient list, patient profile, consultation panels, reports — must use this
 * label rather than the `field.secu.label` catalog key, which still reads
 * "Primary Policy #" in English and "N° Sécurité Sociale" in French.
 *
 * Non-SEHA locales keep `field.secu.label` so US and EU wording is unchanged.
 */
export function usePatientIdentifierLabel(): string {
  useLingui()
  const { t: translate } = useTranslation()
  const isSA = useIsSA()

  return isSA ? t`National ID / Iqama ID / Border Number` : translate('field.secu.label')
}
